import { DASHBOARD, STATUS } from "../constant";
import { isValidArray } from "../helper";

const initState = {
  summaryData: [],
  projectsBySchemesData: [],
  issuesByCategoryData: [],
  issuesByCategoryGanttChartData: [],
  issuesByData: [],
  projectsByData: [],
  projectsByLocationData: [],
  notificationData: [],
  // kanbanApiStatus: null,
  kanbanData: null,
  meetingsData: null,
  notifyStatusData: false,
  notifyStatusUpdateData: [],
  notificationStatus: STATUS.LOADING,
  kanbanListApiStatus: STATUS.LOADING,
  kanbanApiStatus: STATUS.LOADING,
  upcomingMeetingStatus: STATUS.LOADING,
  upcomingMeeting: null,
  childIssueStatus: STATUS.LOADING,
  childIssueData: null,
  pendingTask: [],
  pendingTaskLoading: false,
  showTeamSection: false,
  showTeamSectionStatus: false
};

export default function dashboard(state = initState, action) {
  switch (action.type) {
    case DASHBOARD.DASHBOARD_SUMMARY_START:
      return { ...state, summaryDataStatus: STATUS.LOADING, summaryData: [] };
    case DASHBOARD.DASHBOARD_SUMMARY_SUCCESS: {
      return {
        ...state,
        summaryData: action.payload,
        summaryDataStatus: STATUS.SUCCESS
      };
    }
    case DASHBOARD.DASHBOARD_SUMMARY_FAILURE:
      return { ...state, summaryDataStatus: STATUS.ERROR };

    case DASHBOARD.DASHBOARD_TEAMSECTION_START:
      return { ...state, showTeamSectionStatus: STATUS.LOADING };
    case DASHBOARD.DASHBOARD_TEAMSECTION_SUCCESS: {
      return {
        ...state,
        showTeamSection: action.payload,
        showTeamSectionStatus: STATUS.SUCCESS
      };
    }
    case DASHBOARD.DASHBOARD_TEAMSECTION_FAILURE:
      return { ...state, showTeamSectionStatus: STATUS.ERROR };

    case DASHBOARD.PROJECTS_BY_PRAGATI_START:
      return { ...state, projectsByPragatiDataStatus: STATUS.LOADING };
    case DASHBOARD.PROJECTS_BY_PRAGATI_SUCCESS: {
      return {
        ...state,
        projectsByPragatiData: action.payload,
        projectsByPragatiDataStatus: STATUS.SUCCESS
      };
    }
    case DASHBOARD.PROJECTS_BY_PRAGATI_FAILURE:
      return { ...state, projectsByPragatiDataStatus: STATUS.ERROR };

    case DASHBOARD.DELAYED_PROJECTS_START:
      return { ...state, delayedProjectStatus: STATUS.LOADING };
    case DASHBOARD.DELAYED_PROJECTS_SUCCESS: {
      return {
        ...state,
        delayedProjectData: action.payload,
        delayedProjectStatus: STATUS.SUCCESS
      };
    }
    case DASHBOARD.DELAYED_PROJECTS_FAILURE:
      return { ...state, delayedProjectStatus: STATUS.ERROR };

    case DASHBOARD.ISSUES_BY_CATEGORY_START:
      return { ...state, issuesByCategoryDataStatus: STATUS.LOADING };
    case DASHBOARD.ISSUES_BY_CATEGORY_SUCCESS: {
      return {
        ...state,
        issuesByCategoryData: action.payload,
        issuesByCategoryDataStatus: STATUS.SUCCESS
      };
    }
    case DASHBOARD.ISSUES_BY_CATEGORY_FAILURE:
      return { ...state, issuesByCategoryDataStatus: STATUS.ERROR };

    case DASHBOARD.ISSUES_BY_CATEGORY_GANTT_CHART_START:
      return { ...state, issuesByCategoryGanttChartDataStatus: STATUS.LOADING };
    case DASHBOARD.ISSUES_BY_CATEGORY_GANTT_CHART_SUCCESS: {
      return {
        ...state,
        issuesByCategoryGanttChartData: action.payload,
        issuesByCategoryGanttChartDataStatus: STATUS.SUCCESS
      };
    }
    case DASHBOARD.ISSUES_BY_CATEGORY_GANTT_CHART_FAILURE:
      return { ...state, issuesByCategoryGanttChartDataStatus: STATUS.ERROR };

    case DASHBOARD.PROJECTS_BY_START:
      return { ...state, projectsByDataStatus: STATUS.LOADING };
    case DASHBOARD.PROJECTS_BY_SUCCESS: {
      return {
        ...state,
        projectsByData: action.payload,
        projectsByDataStatus: STATUS.SUCCESS
      };
    }
    case DASHBOARD.PROJECTS_BY_FAILURE:
      return { ...state, projectsByDataStatus: STATUS.ERROR };

    case DASHBOARD.PROJECTS_BY_LOCATION_START:
      return { ...state, projectsByLocationDataStatus: STATUS.LOADING };
    case DASHBOARD.PROJECTS_BY_LOCATION_SUCCESS: {
      return {
        ...state,
        projectsByLocationData: action.payload,
        projectsByLocationDataStatus: STATUS.SUCCESS
      };
    }
    case DASHBOARD.PROJECTS_BY_LOCATION_FAILURE:
      return { ...state, projectsByLocationDataStatus: STATUS.ERROR };

    case DASHBOARD.COST_OVERRUN_PROJECTS_START:
      return { ...state, costOverrunProjectStatus: STATUS.LOADING };
    case DASHBOARD.COST_OVERRUN_PROJECTS_SUCCESS: {
      return {
        ...state,
        costOverrunProjectData: action.payload,
        costOverrunProjectStatus: STATUS.SUCCESS
      };
    }
    case DASHBOARD.COST_OVERRUN_PROJECTS_FAILURE:
      return { ...state, costOverrunProjectStatus: STATUS.ERROR };

    case DASHBOARD.PMG_MEETING_STATUS_START:
      return { ...state, getPmgMeetingStatus: STATUS.LOADING };
    case DASHBOARD.PMG_MEETING_STATUS_SUCCESS: {
      return {
        ...state,
        getPmgMeetingData: action.payload,
        getPmgMeetingStatus: STATUS.SUCCESS
      };
    }
    case DASHBOARD.PMG_MEETING_STATUS_FAILURE:
      return { ...state, getPmgMeetingStatus: STATUS.ERROR };

    case DASHBOARD.PROJECT_STAGES_GRAPHS_START:
      return { ...state, getProjectStagesForGraphsStatus: STATUS.LOADING };
    case DASHBOARD.PROJECT_STAGES_GRAPHS_SUCCESS: {
      return {
        ...state,
        getProjectStagesForGraphsData: action.payload,
        getProjectStagesForGraphsStatus: STATUS.SUCCESS
      };
    }
    case DASHBOARD.PROJECT_STAGES_GRAPHS_FAILURE:
      return { ...state, getProjectStagesForGraphsStatus: STATUS.ERROR };

    case DASHBOARD.ISSUES_BY_START:
      return { ...state, issuesByDataStatus: STATUS.LOADING };
    case DASHBOARD.ISSUES_BY_SUCCESS: {
      return {
        ...state,
        issuesByData: action.payload,
        issuesByDataStatus: STATUS.SUCCESS
      };
    }
    case DASHBOARD.ISSUES_BY_FAILURE:
      return { ...state, issuesByDataStatus: STATUS.ERROR };

    case DASHBOARD.GET_KANBAN_START:
      return { ...state, kanbanApiStatus: STATUS.LOADING };
    case DASHBOARD.GET_KANBAN_SUCCESS:
      return {
        ...state,
        kanbanApiStatus: STATUS.SUCCESS,
        kanbanData: action.payload
      };
    case DASHBOARD.GET_KANBAN_FAILURE:
      return { ...state, meetingsAPIStatus: STATUS.ERROR };

    case DASHBOARD.FETCH_MEETINGS_START:
      return { ...state, meetingsAPIStatus: STATUS.LOADING };
    case DASHBOARD.FETCH_MEETINGS_SUCCESS:
      return {
        ...state,
        meetingsAPIStatus: STATUS.SUCCESS,
        meetingsData: action.payload
      };
    case DASHBOARD.FETCH_MEETINGS_FAILURE:
      return { ...state, meetingsAPIStatus: STATUS.ERROR };

    case DASHBOARD.DASHBOARD_NOTIFICATION_START:
      return {
        ...state,
        notificationStatus: STATUS.LOADING,
        notificationData: []
      };
    case DASHBOARD.DASHBOARD_NOTIFICATION_SUCCESS: {
      let {
        data: { notifications, countOfNotViewedStatus }
      } = action.payload;
      return {
        ...state,
        notificationData: [...state.notificationData, ...notifications],
        countOfNotViewedStatus: countOfNotViewedStatus,
        notificationStatus: STATUS.SUCCESS
      };
    }
    case DASHBOARD.DASHBOARD_NOTIFICATION_FAILURE:
      return {
        ...state,
        notificationStatus: STATUS.ERROR,
        notificationData: []
      };

    case DASHBOARD.DASHBOARD_NOTIFYSTATUS_START:
      return { ...state, notifyStatus: STATUS.LOADING };
    case DASHBOARD.DASHBOARD_NOTIFYSTATUS_SUCCESS: {
      return {
        ...state,
        notifyStatusData: action.payload,
        notifyStatus: STATUS.SUCCESS
      };
    }
    case DASHBOARD.DASHBOARD_NOTIFYSTATUS_FAILURE:
      return { ...state, notifyStatus: STATUS.ERROR };

    //notification-updates
    case DASHBOARD.DASHBOARD_NOTIFYSTATUS_UPDATES_START:
      return { ...state, notifyStatus: STATUS.LOADING };
    case DASHBOARD.DASHBOARD_NOTIFYSTATUS_UPDATES_SUCCESS: {
      return {
        ...state,
        notifyStatusUpdateData: action.payload,
        notifyStatus: STATUS.SUCCESS
      };
    }
    case DASHBOARD.DASHBOARD_NOTIFYSTATUS_UPDATES_FAILURE: {
      return { ...state, notifyStatus: STATUS.ERROR };
    }

    case DASHBOARD.GET_KANBAN_LIST_START:
      return { ...state, kanbanListApiStatus: STATUS.LOADING };
    case DASHBOARD.GET_KANBAN_LIST_SUCCESS:
      return {
        ...state,
        kanbanListApiStatus: STATUS.SUCCESS,
        kanbanList: action.payload
      };
    case DASHBOARD.GET_KANBAN_LIST_FAILURE:
      return { ...state, kanbanListApiStatus: STATUS.ERROR };

    case DASHBOARD.GET_UPCOMING_MEETINGS_START:
      return {
        ...state,
        upcomingMeetingStatus: STATUS.LOADING,
        upcomingMeeting: null
      };
    case DASHBOARD.GET_UPCOMING_MEETINGS_SUCCESS:
      return {
        ...state,
        upcomingMeetingStatus: STATUS.SUCCESS,
        upcomingMeeting: action.payload
      };
    case DASHBOARD.GET_UPCOMING_MEETINGS_FAILURE:
      return {
        ...state,
        upcomingMeetingStatus: STATUS.ERROR,
        upcomingMeeting: null
      };

    case DASHBOARD.GET_CHILD_ISSUE_START:
      return {
        ...state,
        childIssueStatus: STATUS.LOADING,
        childIssueData: null
      };
    case DASHBOARD.GET_CHILD_ISSUE_SUCCESS:
      return {
        ...state,
        childIssueStatus: STATUS.SUCCESS,
        childIssueData: action.payload
      };
    case DASHBOARD.GET_CHILD_ISSUE_FAILURE:
      return {
        ...state,
        childIssueStatus: STATUS.ERROR,
        childIssueData: null
      };

    case DASHBOARD._START:
      return {
        ...state,
        pendingTaskLoading: STATUS.LOADING,
        pendingTask: []
      };
    case DASHBOARD._SUCCESS:
      const data = Object.entries(action.payload);
      const filteredData = data.filter(item => item[0] !== "pendingComments");
      return {
        ...state,
        pendingTaskLoading: false,
        pendingTask:
          !isValidArray(filteredData[0][1]) && !isValidArray(filteredData[1][1])
            ? []
            : filteredData
      };

    case DASHBOARD._FAILURE:
      return {
        ...state,
        pendingTaskLoading: false,
        pendingTask: []
      };

    default:
      return state;
  }
}
